import React from "react";

/** Props Interface */
interface ChartHeaderProps {
	title: string;
	description?: string;
	controls?: React.ReactNode;
}

export function ChartHeader({ title, description, controls }: ChartHeaderProps) {
	return (
		<div className="h-stack items-start">
			<div className="w-max h-max v-stack mb-4 gap-0">
				<p className="text-xl font-semibold">{title}</p>
				{description && <p className="label">{description}</p>}
			</div>
			{controls && <React.Fragment>{controls}</React.Fragment>}
		</div>
	);
}
